import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { HighlightPipe } from '../highlight.pipe';

@Component({
  selector: 'app-see-more-popup',
  standalone: true,
  imports: [CommonModule, HighlightPipe],
  templateUrl: './see-more-popup.component.html',
  styleUrl: './see-more-popup.component.scss',
})
export class SeeMorePopupComponent {
  popupData: any;
  searchText: string = '';
  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<SeeMorePopupComponent>,
    //public dialogRef1: MatDialogRef<SeeMorePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.popupData = this.data;
    this.searchText = data.searchText || '';
    // Only sort if there is a search string and items
    if (this.searchText && Array.isArray(this.popupData.items)) {
      this.popupData.items = this.sortItems(
        this.popupData.items,
        this.searchText
      );
    }
  }

  /**
   * Sort items where exact phrase match comes first, then all words, then any word, then the rest.
   */
  // sortItems(items: any[], searchText: string): any[] {
  //   if (!searchText.trim()) return items;
  //   const words = searchText.trim().toLowerCase().split(/\s+/).filter(Boolean);

  //   function getTextFields(item: any): string {
  //     let str = '';
  //     if (item.name) str += item.name + ' ';
  //     if (item.title) str += item.title + ' ';
  //     if (item.display) str += item.display + ' ';
  //     if (item.statement) str += item.statement + ' ';
  //     return str.trim().toLowerCase();
  //   }

  //   function matchScore(item: any): number[] {
  //     const text = getTextFields(item);

  //     // 1. Exact match for all words (in any order)
  //     const allWordsMatch = words.every((word) => text.includes(word)) ? 1 : 0;

  //     // 2. Text starts with first word
  //     const startsWithFirst = text.startsWith(words[0]) ? 1 : 0;

  //     // 3. Contains second word (if present)
  //     const containsSecond = words[1] && text.includes(words[1]) ? 1 : 0;

  //     // 4. Contains third word (if present)
  //     const containsThird = words[2] && text.includes(words[2]) ? 1 : 0;

  //     // 5. Number of matched words
  //     const matchedWords = words.reduce(
  //       (acc, word) => acc + (text.includes(word) ? 1 : 0),
  //       0
  //     );

  //     // Return as array for lexicographic sort (higher first)
  //     return [
  //       allWordsMatch,
  //       startsWithFirst,
  //       containsSecond,
  //       containsThird,
  //       matchedWords,
  //     ];
  //   }

  //   return [...items].sort((a, b) => {
  //     const scoreA = matchScore(a);
  //     const scoreB = matchScore(b);
  //     for (let i = 0; i < scoreA.length; i++) {
  //       if (scoreB[i] !== scoreA[i]) return scoreB[i] - scoreA[i];
  //     }
  //     // Fallback: alphabetical order
  //     return getTextFields(a).localeCompare(getTextFields(b));
  //   });
  // }

  sortItems(items: any[], searchText: string): any[] {
    if (!searchText.trim()) return items;

    const lowerSearchText = searchText.trim().toLowerCase();
    const words = lowerSearchText.split(/\s+/).filter(Boolean);

    function getTextFields(item: any): string {
      let str = '';
      if (item.name) str += item.name + ' ';
      if (item.title) str += item.title + ' ';
      if (item.display) str += item.display + ' ';
      if (item.statement) str += item.statement + ' ';
      return str.trim().toLowerCase();
    }

    function matchScore(item: any): number[] {
      const text = getTextFields(item);

      const exactPhraseMatch = text.includes(lowerSearchText) ? 1 : 0;
      const allWordsMatch = words.every((word) => text.includes(word)) ? 1 : 0;
      const matchedWords = words.reduce(
        (acc, word) => acc + (text.includes(word) ? 1 : 0),
        0
      );

      return [exactPhraseMatch, allWordsMatch, matchedWords];
    }

    return [...items].sort((a, b) => {
      const scoreA = matchScore(a);
      const scoreB = matchScore(b);

      for (let i = 0; i < scoreA.length; i++) {
        if (scoreB[i] !== scoreA[i]) return scoreB[i] - scoreA[i];
      }

      return getTextFields(a).localeCompare(getTextFields(b));
    });
  }

  oncancelClick() {
    this.dialogRef.close(false);
  }
}
